export const isImportPermission = (consumerCapability) => {
    return consumerCapability.indexOf('_IMPORT') > -1;
};

export const isGdprUploadConsentRequired = (capability) => {
    return isImportPermission(capability.consumerCapability) && capability.uploadConsentRequired;
};
